module.exports = __webpack_public_path__ + "img/ultra_2_feature_01.c9ced1eb.jpg";